import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M12.5 3c0 .487-.125.975-.25 1.462-.132.513-.264 1.025-.25 1.538.013.461.301 1.112.695 1.792 1.203 2.076 1.61 4.599.537 6.745L12.5 16h-4l-.718-1.437c-1.08-2.159-.654-4.696.55-6.788C8.722 7.102 9 6.458 9 6c0-.505-.127-1.018-.253-1.527C8.623 3.973 8.5 3.478 8.5 3a2 2 0 0 1 4 0Zm-9.386.6h-.002c0-.884.686-1.6 1.532-1.6.845 0 1.53.716 1.53 1.6h.002c0 .39-.096.78-.192 1.17-.1.41-.202.82-.19 1.23.01.423.3 1.045.668 1.673.043.072.083.144.123.218-.86 1.855-1.23 4.031-.628 6.11H3.114l-.679-1.418c-.754-1.576-.472-3.415.413-4.921.366-.625.648-1.242.648-1.662 0-.404-.097-.815-.194-1.222-.095-.4-.188-.796-.188-1.178Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var IconInfrastructureBowling16 = createIcon(IconComponent);